import React from 'react';

import { Tooltip } from '@material-ui/core';

import { useIsOverflow } from '../../common/hooks/useIsOverflow';

const EllipsisSection = ({ text, className, elementWidth }) => {
    const ref = React.useRef();
    const isOverflow = useIsOverflow(ref, (isOverflowFromCallback) => {});
    return isOverflow ? (
        <Tooltip arrow title={text} placement={'top'} enterTouchDelay={0}>
            <div style={{ width: elementWidth }}>
                <h3 className={className}>{text}</h3>
            </div>
        </Tooltip>
    ) : (
        <div style={{ width: elementWidth }}>
            <h3 className={className} ref={ref}>
                {text}
            </h3>
        </div>
    );
};

export default EllipsisSection;
